import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber } from '@shared/components'
import { DEFAULT_CURRENCY } from '@shared/constants'
import { Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

type Props = {
  fieldKey: number
}

export const InsuredAmount = ({ fieldKey }: Props) => {
  const { t } = useTranslation()
  const { required } = useValidationsField()

  const { costProps, insuredAmountProps, itemsKey } = formProps(t)

  const cost = Form.useWatch([itemsKey.name, fieldKey, costProps.name])

  return (
    <Row gutter={[12, 12]}>
      <Col xs={{ span: 24 }} md={{ span: 8 }}>
        <Form.Item
          {...costProps}
          name={[fieldKey, costProps.name]}
          rules={[required]}
        >
          <InputParsedNumber min={0} placeholder={costProps.label} />
        </Form.Item>
      </Col>

      <Col xs={{ span: 24 }} md={{ span: 8 }}>
        <Form.Item
          {...insuredAmountProps}
          name={[fieldKey, insuredAmountProps.name]}
          rules={[required]}
        >
          <InputParsedNumber
            min={0}
            max={cost}
            disabled={!cost}
            placeholder={insuredAmountProps.label}
          />
        </Form.Item>
      </Col>

      <Col xs={{ span: 24 }} md={{ span: 8 }}>
        <Form.Item label={t('currency')}>
          <Input
            disabled
            placeholder={t('currency')}
            value={DEFAULT_CURRENCY}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
